import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import config from "@/lib/config";
import { maskTargetKeys, metaSchemas, userRating } from "@/lib/constants";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";
function recurciveMask() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const copiedData = JSON.parse(JSON.stringify(data));
  function mask(key, value) {
    if (Array.isArray(value)) {
      return value.map(v => mask(key, v));
    } else if (typeof value === "object") {
      return recurciveMask(value);
    } else if (typeof value === "string") {
      if (maskTargetKeys.includes(key)) {
        return value.replace(/./g, "*");
      } else {
        return value;
      }
    }
    return value;
  }
  for (const key in copiedData) {
    const value = copiedData[key];
    copiedData[key] = mask(key, value);
  }
  return copiedData;
}
class LogicaAPI extends RESTDataSource {
  constructor(options) {
    super(options);
    _defineProperty(this, "baseURL", config.api.vcmsURL);
    this.context = options;
  }
  get config() {
    var _this$context$req, _this$context$req2, _this$context$req3;
    return {
      service: config.service,
      deviceCode: this.context.req.deviceCode,
      appId: config.appId["vod"],
      storeId: config.storeId["vod"],
      valuePlanId: config.valuePlanId["vod"],
      userId: (_this$context$req = this.context.req) === null || _this$context$req === void 0 || (_this$context$req = _this$context$req.userToken) === null || _this$context$req === void 0 ? void 0 : _this$context$req.id,
      profileId: (_this$context$req2 = this.context.req) === null || _this$context$req2 === void 0 || (_this$context$req2 = _this$context$req2.userToken) === null || _this$context$req2 === void 0 ? void 0 : _this$context$req2.currentProfile,
      rating: (_this$context$req3 = this.context.req) === null || _this$context$req3 === void 0 || (_this$context$req3 = _this$context$req3.userToken) === null || _this$context$req3 === void 0 ? void 0 : _this$context$req3.rating
    };
  }
  get dsearchCommonParams() {
    return {
      service: this.config.service,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      datasource: "decorator"
    };
  }
  get dsearchCommonCondition() {
    const condition = {
      "values.adult_flag": false
    };
    if (this.isMaybeLoggedIn() && typeof this.config.rating === "number") {
      condition["values.rating"] = userRating[this.config.rating].permitRating;
    }
    return condition;
  }
  dsearchContentTypeCondition(contentType) {
    switch (contentType) {
      case "vod":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": false
        };
      case "catchup":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": true,
          "values.catch_up_flag": true,
          time_range: {
            "values.encode_end_date": {
              lt: "now"
            },
            delivery_end_at: {
              gt: "now"
            }
          }
        };
      case "live":
        return {
          meta_schema_id: metaSchemas.episode.id,
          "values.is_live": true,
          time_range: {
            "values.encode_end_date": {
              gt: "now"
            }
          }
        };
      case "episode":
        return {
          meta_schema_id: metaSchemas.episode.id
        };
      case "channel":
        return {
          meta_schema_id: metaSchemas.channel.id
        };
      case "all":
        return {};
    }
  }
  isMaybeLoggedIn() {
    var _this$context$req4;
    return !!((_this$context$req4 = this.context.req) !== null && _this$context$req4 !== void 0 && _this$context$req4.userToken);
  }
  willSendRequest(_path, request) {
    var _this$context$req5, _this$context$req6, _this$context$req7, _this$context$req8;
    // IPアドレスをforward
    const remoteIp = getRemoteIpAddress(this.context.req);
    request.headers["X-Forwarded-For"] = remoteIp;
    // UAをプロキシする
    request.headers["User-Agent"] = `${(_this$context$req5 = this.context.req) === null || _this$context$req5 === void 0 || (_this$context$req5 = _this$context$req5.deviceInfo) === null || _this$context$req5 === void 0 ? void 0 : _this$context$req5.ua} spooxweb`;
    if ((_this$context$req6 = this.context.req) !== null && _this$context$req6 !== void 0 && _this$context$req6.userToken) {
      const {
        id,
        accessToken
      } = this.context.req.userToken;
      request.headers["X-User-Id"] = id;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
      if (_path === "/api/v1/metas/dsearch" && request.params instanceof URLSearchParams) {
        request.params.append("user_id", id);
      }
    }
    if (_path === "/api/v1/users/existed" || _path === "/api/v1/users/password_update" || _path === "/api/v1/users/regist") {
      request.headers["X-Api-Key"] = config.logica.apikey;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Logica-Request-Id"] = requestId;
    const requestParams = request.params || null;
    const userId = request.headers["X-User-Id"];
    const operationName = ((_this$context$req7 = this.context.req) === null || _this$context$req7 === void 0 || (_this$context$req7 = _this$context$req7.query) === null || _this$context$req7 === void 0 ? void 0 : _this$context$req7.operationName) || "unknown";
    const url = ((_this$context$req8 = this.context.req) === null || _this$context$req8 === void 0 ? void 0 : _this$context$req8.url) || "unknown";
    try {
      // 個人情報をマスクする
      const maskedBody = recurciveMask(request.body);
      const maskedBodyStr = JSON.stringify(maskedBody || null);
      console.log(`[${requestId}][Logica][REQUEST INFO] Method: ${request.method}, Path: ${_path}, Params: ${requestParams}, UserId: ${userId}, Body: ${maskedBodyStr}, OperationName: ${operationName}, URL: ${url} `);
    } catch (e) {
      // 万が一エラーになってもサービスを止めないようにエラーを潰す
      console.log(e);
    }
  }
  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Logica-Request-Id"];
    const responseBody = await super.didReceiveResponse(response, request);
    const logicaRequestId = responseBody === null || responseBody === void 0 ? void 0 : responseBody.request_id;
    console.log(`[${requestId}][Logica][RESPONSE INFO] request_id: ${logicaRequestId} Status: ${response.status}`);
    return responseBody;
  }
}
export default LogicaAPI;